var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.isRenderPlayerRegistrationFlow &&
      !_vm.allEventOptionsAtCapacity &&
      !_vm.userNotInvited
  )?_c('div',{staticClass:"player-registration d-flex flex-column align-center flex-md-row align-md-start"},[(_vm.formStep !== 3)?_c('PlayerRegistrationPlayerDetails',{on:{"showPlayerAvatarCropModal":function($event){_vm.showPlayerAvatarCropModal = true}}}):_vm._e(),_c('PlayerRegistrationForm',{attrs:{"formStep":_vm.formStep,"moveToFormStep":_vm.moveToFormStep}}),(_vm.showPlayerAvatarCropModal)?_c('PlayerAvatarCropModal',{on:{"close":function($event){_vm.showPlayerAvatarCropModal = false}}}):_vm._e()],1):(
    !_vm.isRenderPlayerRegistrationFlow ||
      _vm.allEventOptionsAtCapacity ||
      _vm.userNotInvited
  )?_c('PlayerRegistrationClosePage'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }